import { Box, Stack, Typography } from '@mui/material';
import type { ApplicableVirtualMediaDto } from '@/types/dtos/media/virtual-media.dto';
import type { PlaylistVirtualMediaTemplateDto } from '@/types/dtos/media/virtual-media.dto';
import MediaSettingsSwitchRow from '@/components/media/media-settings-switch-row';
import { useTranslations } from '@/i18n/use-translations';

type EventVirtualMediaMatrixRowProps = {
  label: string;
  template?: PlaylistVirtualMediaTemplateDto;
  applicable: ApplicableVirtualMediaDto[];
  canEdit: boolean;
  disabled?: boolean;
  onToggleSlug: (slug: string, enabled: boolean) => void;
};

export default function EventVirtualMediaMatrixRow({
  label,
  template,
  applicable,
  canEdit,
  disabled = false,
  onToggleSlug,
}: EventVirtualMediaMatrixRowProps) {
  const t = useTranslations();
  const enabledSlugs = new Set(template?.enabledSlugs ?? []);

  return (
    <Box>
      <Typography variant="subtitle2" gutterBottom>
        {label}
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
        {t('media.virtualSettings.matrix.applicableCount', { count: applicable.length })}
      </Typography>
      <Stack spacing={0.5}>
        {[...applicable]
          .sort((a, b) => a.sortOrder - b.sortOrder || a.name.localeCompare(b.name))
          .map((item) => (
            <MediaSettingsSwitchRow
              key={item.slug}
              switchKey={`matrix-${label}-${item.slug}-${enabledSlugs.has(item.slug)}`}
              label={item.name}
              checked={enabledSlugs.has(item.slug)}
              disabled={!canEdit || disabled}
              onChange={(v) => onToggleSlug(item.slug, v)}
            />
          ))}
      </Stack>
    </Box>
  );
}
